import { resolveCtaTag } from './ctaTelemetry';

export const CTA_TELEMETRY_ENDPOINT = '/api/telemetry/cta';

export function registerCtaClickListener(): () => void {
    document.addEventListener('click', reportCtaClick, true);
    return () => document.removeEventListener('click', reportCtaClick, true);
}

function reportCtaClick(event: MouseEvent): void {
    const tag = resolveCtaTag(event.target, window.location);
    if (tag === undefined) return;

    fetch(CTA_TELEMETRY_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: tag,
        keepalive: true,
    }).catch(() => undefined);
}
